import { render, staticRenderFns } from "./StoreCampaigns.vue?vue&type=template&id=0c79c1e2&"
import script from "./StoreCampaigns.vue?vue&type=script&lang=ts&"
export * from "./StoreCampaigns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports